@use '@lib/assets/styles/main.scss' as *;
.titleWrap {
  display: inline-grid;
  grid-template-columns: auto min-content;
  grid-gap: 4px;
  align-items: center;
  margin-bottom: 16px;
}

.title {
  margin-bottom: 16px;
}

.infoIcon {
  color: $gray400;
  cursor: pointer;
  display: block;
}
